import React from 'react'
import {
    FormGroup,
    Input,
    Label,
    Col
  } from 'reactstrap';
import Subtitle from '../../subtitle/Subtitle'
export default props => {
    return (
        <div>
            <Subtitle text="Credenciais"/>
            <FormGroup row className="my-0">
                <Col xs="12" lg="6">
                    <FormGroup>
                        <Label htmlFor="user">Usuário</Label>
                        <Input type="text" id="user" autoFocus autoComplete="new-user" placeholder="sysdba" defaultValue={props.entity.user} onChange={event => props.handleChange('user', event.target.value)}/>
                    </FormGroup>
                </Col>
                <Col xs="12" lg="6">
                    <FormGroup>
                        <Label htmlFor="password">Senha</Label>
                        <Input type="password" id="password" autoComplete="new-password" placeholder="******" defaultValue={props.entity.password} onChange={event => props.handleChange('password', event.target.value)}/>
                    </FormGroup>
                </Col>
            </FormGroup>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/views/components/migration-form/credentials/MigrationCredentialsForm.js